import React from 'react';
import lightModeLogo from '../assets/opsight-logo-light.svg';
import darkModeLogo from '../assets/opsight-logo-dark.svg';

interface OpsightLogoProps {
  size?: number;
  className?: string;
  variant?: 'light' | 'dark';
}

export const OpsightLogo: React.FC<OpsightLogoProps> = ({ 
  size = 120, 
  className = '', 
  variant 
}) => {
  // Para landing page, usar sempre light mode por padrão
  const logoSrc = variant === 'dark' ? darkModeLogo : lightModeLogo;
  
  // Calcular altura proporcional (viewBox original é 375x150)
  const aspectRatio = 375 / 150;
  const height = size / aspectRatio;

  return (
    <img
      src={logoSrc}
      alt="Opsight"
      className={className}
      style={{
        width: `${size}px`,
        height: `${height}px`,
        display: 'block',
        backgroundColor: 'transparent',
        mixBlendMode: 'normal',
      }}
    />
  );
};









